import { Accordion, Col, Container, Row } from "react-bootstrap";
import NavBar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./KnowledgeCenter.css";
// import techImg from "../../assets/img/tech.jpg";
import { Helmet } from "react-helmet";
import un from "../../assets/awards/un.jpeg";
import adhd from "../../assets/img/New-Pages/Knowledge-Center/adhd.jpg"
export default function Adhd() {
    return (
        <>
            <Helmet>
                <title>
                    Technology & Innovation | Manzil Center -Special Families Support
                </title>
                <meta
                    name="description"
                    content="Technology & Innovation: Immersive Technology, AI-based Assessments & Training, LMS (Learning Management System) Manzil Center"
                />
                <meta name="keywords" content="Manzil center, Special Family Support, Technology and Innovation, special need school, Autism Center in Sharjah, NGO in Sharjah, Sharjah, UAE, special EMPLOYMENT PROGRAM in sharjah" />
                <link
                    rel="canonical"
                    href="https://www.manzil.ae/technology-innovation"
                />
                <meta
                    property="og:title"
                    content="Technology & Innovation | Manzil Center -Special Families Support"
                />
                <meta
                    property="og:description"
                    content="Technology & Innovation: Immersive Technology, AI-based Assessments & Training, LMS (Learning Management System) Manzil Center"
                />
                <meta
                    property="og:url"
                    content="https://www.manzil.ae/technology-innovation"
                />
                <meta
                    property="og:image"
                    content="https://www.manzil.ae/static/media/tech.c36c4b39166f77bc379f.jpg"
                />
                <meta
                    name="twitter:title"
                    content="Technology & Innovation | Manzil Center -Special Families Support"
                />
                <meta
                    name="twitter:description"
                    content="Technology & Innovation: Immersive Technology, AI-based Assessments & Training, LMS (Learning Management System) Manzil Center"
                />
                <meta
                    name="twitter:image"
                    content="https://www.manzil.ae/static/media/tech.c36c4b39166f77bc379f.jpg"
                />
            </Helmet>
            <NavBar />
            <div className="page-title-area tech-inner">
                <div className="container-fluid h-100 d-flex justify-content-center align-items-center">
                    <div className="page-title-content">
                        <ul>
                            {/* <li>
                <a href="/">Home</a>
              </li> */}
                            <li>
                                <h1>ADHD</h1>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* <Container className="my-4 pt-5">
        <Row>
          <Col lg={5}>
            <div class="tp-about-us__main-thumb">
              <img
                className="img-fluid"
                src="https://wphix.com/wp/poorex/wp-content/uploads/2023/07/about-us-1-1.jpg"
                alt=""
              />
              <div class="tp-about-us__thumb-sm">
                <img
                  className="img-fluid"
                  src="https://wphix.com/wp/poorex/wp-content/uploads/2023/07/about-us-1-2.jpg"
                  alt=""
                />
              </div>
              <div class="tp-about-us__thumb-border"></div>
            </div>
          </Col>
          <Col lg={7} className="ps-lg-5">
            <div className="ps-lg-5">
              <div className="main-heading">
                <h2 className="mb-4 m-0">Technology and Innovation</h2>
              </div>
              <p>
                Manzil has always been at the forefront of innovation and
                adopting best practices to impart knowledge.
              </p>
              <p>
                Working closely with a leading UAE AR/VR startup, we have
                created the region’s first immersive training experience for the
                hospitality sector. This will be accompanied by a research paper
                delving deeper into what works - and what doesn’t- especially
                for PwDs.
              </p>
              <p>
                We are also working on a medium term programme using NLP and
                machine learning to assess individuals, create training
                programmes and then match them to existing job opportunities.
                This could become a game changer in the way people are connected
                with the right opportunity!
              </p>
              <p>
                Lastly, we have also launched our online Learning Management
                System which has training content from Basic to Advanced levels
                covering a wide range of non academic subjects.
              </p>
            </div>
          </Col>
        </Row>
      </Container> */}

            <Container className="my-4 pb-lg-5">
                <Row>
                    <Col lg={12}>
                        <div className="main-heading text-center mb-5">
                            {/* <span className="center">Technology Driving Services</span> */}
                            <p>
                                Manzil has always been at the forefront of innovation and
                                adopting best practices to acquire and impart knowledge. Here
                                are some of the things we are doing (and working on to launch
                                soon!) especially when it comes to the use of technology.
                            </p>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <img src={adhd} className="img-fluid h-100 object-fit-cover" alt="Immersive Technology , AI based Assessments & Training , LMS | Manzil" />
                    </Col>

                    <Col lg={6}>
                        {/* <Row>
                            <Col md={12} className="mb-4">
                                <div className="oracle-partner-card">
                                    <h5>What is Down Syndrome and how does it affect learning?</h5>
                                    <p className="mb-1">

                                        Down syndrome is a genetic condition causing developmental delays and intellectual disability. Individuals often learn at a slower pace but benefit from structured support.

                                    </p>
                                    <a href="https://us.sagepub.com/sites/default/files/upm-assets/81536_book_item_81536.pdf" target="_blank" className=" default-btn">Source</a>
                                </div>
                            </Col>
                            <Col md={12} className="mb-4">
                                <div className="oracle-partner-card">
                                    <h5>What are the benefits of early intervention?</h5>
                                    <p className="mb-1">

                                        Early support in speech, physical, and occupational therapy improves developmental outcomes.

                                    </p>
                                    <a href="https://us.sagepub.com/sites/default/files/upm-assets/81536_book_item_81536.pdf" target="_blank" className=" default-btn">Source</a>
                                </div>
                            </Col>
                            <Col md={12} className="mb-4">
                                <div className="oracle-partner-card">
                                    <h5>Can children with Down syndrome attend mainstream schools?
                                    </h5>
                                    <p className="mb-1">

                                        Yes, with the right support in place. Inclusive education enhances social and academic growth.

                                    </p>
                                    <a href="https://us.sagepub.com/sites/default/files/upm-assets/81536_book_item_81536.pdf" target="_blank" className=" default-btn">Source</a>
                                </div>
                            </Col>
                            <Col md={12} className="mb-4">
                                <div className="oracle-partner-card">
                                    <h5>Are there job opportunities for adults with Down syndrome?
                                    </h5>
                                    <p className="mb-1">


                                        Yes, especially in inclusive companies offering supported employment.
                                    </p>
                                    <a href="https://us.sagepub.com/sites/default/files/upm-assets/81536_book_item_81536.pdf" target="_blank" className=" default-btn">Source</a>
                                </div>
                            </Col>
                            <Col md={12} className="mb-4">
                                <div className="oracle-partner-card">
                                    <h5>How can families support learning at home?
                                    </h5>
                                    <p className="mb-1">


                                        Use repetition, visual aids, and routines.
                                    </p>
                                    <a href="https://us.sagepub.com/sites/default/files/upm-assets/81536_book_item_81536.pdf" target="_blank" className=" default-btn">Source</a>
                                </div>
                            </Col>





                        </Row> */}

                        {/* <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>What is Down Syndrome and how does it affect learning?</Accordion.Header>
                                <Accordion.Body>
                                    Down syndrome is a genetic condition causing developmental delays and intellectual disability. Individuals often learn at a slower pace but benefit from structured support.
                                    <a href="/corporate-training" class="default-btn default-btn-orange me-0 nav-link">Read More</a>

                                </Accordion.Body>

                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>What are the benefits of early intervention?
                                </Accordion.Header>
                                <Accordion.Body>
                                    Early support in speech, physical, and occupational therapy improves developmental outcomes.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Can children with Down syndrome attend mainstream schools?

                                </Accordion.Header>
                                <Accordion.Body>
                                    Yes, with the right support in place. Inclusive education enhances social and academic growth.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>Are there job opportunities for adults with Down syndrome?

                                </Accordion.Header>
                                <Accordion.Body>
                                    Yes, especially in inclusive companies offering supported employment.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>How can families support learning at home?


                                </Accordion.Header>
                                <Accordion.Body>

                                    Use repetition, visual aids, and routines.                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion> */}
                        <div className="down-content border-bottom pb-3 mb-3 mt-lg-0 mt-3">
                            <h6>What are the core symptoms of ADHD?



                            </h6>
                            <p className="mb-2">  Inattention, impulsivity, and hyperactivity.

                            </p>
                            <div>
                                <a href="/https://www.nimh.nih.gov/sites/default/files/documents/health/publications/adhd-2024.pdf" class="default-btn default-btn-orange me-0 nav-link">Source</a>
                            </div>

                        </div>
                        <div className="down-content border-bottom  pb-3 mb-3">
                            <h6>How can schools support students with ADHD?



                            </h6>
                            <p className="mb-2"> With structure, visual cues, and regular feedback.




                            </p>
                            <div>
                                <a href="/https://education.wm.edu/centers/ttac/documents/packets/adhd.pdf" class="default-btn default-btn-orange me-0 nav-link">Source</a>
                            </div>

                        </div>
                        <div className="down-content border-bottom pb-3 mb-3">
                            <h6>Are there workplace accommodations for ADHD?


                            </h6>
                            <p className="mb-2">  Yes—task prioritization tools, flexible hours, and clear instructions help.




                            </p>
                            <div>
                                <a href="/https://www.adhdfoundation.org.uk/wp-content/uploads/2022/03/An-Employers-Guide-to-ADHD-in-the-Workplace-Scottish-ADHD-Coalition-1.pdf" class="default-btn default-btn-orange me-0 nav-link">Source</a>
                            </div>

                        </div>
                        <div className="down-content border-bottom pb-3 mb-3">
                            <h6>Is medication necessary?

                            </h6>
                            <p className="mb-2">

                                Not always. Behavioral therapy and lifestyle changes may suffice.                            </p>
                            <div>
                                <a href="/https://ictp.uw.edu/sites/default/files/ADHD_Medications_and_Other_Treatments_William_French_MD_01-12-17.pdf" class="default-btn default-btn-orange me-0 nav-link">Source</a>
                            </div>

                        </div>
                        <div className="down-content">
                            <h6>
                                Can adults have undiagnosed ADHD?

                            </h6>
                            <p className="mb-2">
                                Use repetition, visual aids, and routines.

                            </p>
                            <div>
                                <a href="/https://adhdfoundation.org.au/wp-content/uploads/2020/06/ADULT-ADHD.pdf" class="default-btn default-btn-orange me-0 nav-link">Source</a>
                            </div>

                        </div>



                    </Col>




                </Row>
            </Container>
            <Footer />
        </>
    );
}
